import { useMutation, useQueryClient } from "@tanstack/react-query";
import { MARK_MESSAGE_AS_READ } from "../api/queries";
import { graphQLClient } from "../graphqlClient";

export const useMarkMessageAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ messageID, userID, path }) => {
      const contractTTL = Math.floor(Date.now() / 1000); // Current timestamp in seconds
      return graphQLClient.request(MARK_MESSAGE_AS_READ, {
        messageID,
        userID,
        path,
        contractTTL,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },
    onError: (error) => {
      console.error("Error marking message as read:", error);
    },
  });
};
